import { isLeFlightSavedItemData } from 'tripPlanner/api/types'
import type { CartPanelItem } from '../hooks/useCartPanelItems'

/**
 * The shared `flightGroupId` of a multi-city leg, or `undefined` for any item
 * that is not a multi-city flight leg. Multi-city itineraries persist one trip
 * item per leg, all sharing this id.
 */
export function getMultiCityGroupId(item: CartPanelItem): string | undefined {
  if (item.productType !== 'flight' || !isLeFlightSavedItemData(item.savedItemData)) return undefined
  return item.savedItemData.flightGroupType === 'multi_city' ? item.savedItemData.flightGroupId : undefined
}

/**
 * A leg's position within its multi-city group. Falls back to
 * `Number.MAX_SAFE_INTEGER` so legs missing an order sort to the end rather than
 * jumping to the front.
 */
export function getMultiCityLegOrder(item: CartPanelItem): number {
  if (item.productType !== 'flight' || !isLeFlightSavedItemData(item.savedItemData)) return Number.MAX_SAFE_INTEGER
  return item.savedItemData.legOrder ?? Number.MAX_SAFE_INTEGER
}
